var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['home', {'no-webp': !_vm.webp}]},[_c('showreel'),_c('services'),_c('process'),_c('technologies'),_c('contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }